<template>
  <v-container
    fluid
    class="transporter-details-page transporter-drivers-page ops-entry-form-page ops-entry-form-page--transporter ops-entry-form-page--edit"
  >
    <SelectCountry
      :open="selectCountryDialog"
      @closeSelectCountry="selectCountryDialog = false"
      :type="`/transporter/add/${this.$route.params._id}`"
    />
    <!-- Same shell as TransporterDetail (Basic Details tab) so switching tabs
         doesn't shift the layout. -->
    <v-card
      raised
      v-if="showScreen"
      class="transporter-details-card ops-entry-form-card"
    >
      <loading :active.sync="loading" />
      <v-card-text class="transporter-details-body content-border">
        <v-tabs
          class="m-b-20 customer-details-tabs transporter-details-tabs"
          v-model="changeTabListing"
        >
          <v-tab
            :href="`#basicDetail`"
            class="customer-details-tab transporter-details-tab"
            @click="
              filterByTab('basicDetail');
              $router.push(
                `/transporter/edit/${$route.params.id}/${$route.params._id}/${$route.params.country}/true`
              );
            "
          >
            <v-icon small class="customer-details-tab__icon">
              business
            </v-icon>
            <span class="customer-details-tab__label">Basic Details</span>
          </v-tab>
          <v-tab
            :href="`#drivers`"
            class="customer-details-tab transporter-details-tab"
            @click="filterByTab('drivers')"
          >
            <v-icon small class="customer-details-tab__icon">
              group
            </v-icon>
            <span class="customer-details-tab__label">Drivers</span>
          </v-tab>
        </v-tabs>

        <div class="transporter-details-view transporter-drivers-view">
          <FilterBoard
            class="transporter-drivers-filter-row oms-list-filter"
            eyebrow=""
            title="Driver directory"
          >
            <template slot="header-actions">
              <button
                v-permissions="'register-new-driver'"
                class="oms-action-card-button transporter-drivers-add-btn"
                type="button"
                @click="checkAdd()"
              >
                <span class="oms-action-card-button__icon">
                  <v-icon>add</v-icon>
                </span>
                <span class="oms-action-card-button__label">
                  Register New Driver
                </span>
              </button>
            </template>

            <v-flex
              xs12
              sm6
              md3
              class="oms-filter-board__field transporter-drivers-filter-field--type"
            >
              <v-select
                v-model="searchTypes"
                :items="searchItems"
                label="Search Type"
                item-text="status"
                single-line
                item-value="abbr"
                @change="searchByType()"
                return-object
                hide-details
                outline
              ></v-select>
            </v-flex>
            <v-flex
              xs12
              sm6
              md4
              class="oms-filter-board__field transporter-drivers-filter-field--search"
            >
              <v-text-field
                label="Search here.."
                outline
                :disabled="!searchTypes"
                single-line
                v-model="search.text"
                @keyup.delete="searchDriver"
                @keyup.enter="searchDriver"
                @click:append="searchDriver"
                append-icon="search"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm6
              md3
              class="oms-filter-board__field transporter-drivers-filter-field--availability"
            >
              <v-select
                label="Availability"
                :items="availableStatus"
                @change="searchDriverStatus()"
                v-model="status"
                single-line
                hide-details
                outline
              />
            </v-flex>
            <v-flex
              xs12
              sm6
              md2
              class="reset-btn oms-filter-board__actions transporter-drivers-filter-field--reset"
            >
              <v-card-actions class="justify-center">
                <v-btn
                  class="reset-btn-color oms-filter-board__reset"
                  flat
                  prepend-icon
                  color="orange darken-1"
                  @click.native="resetSearch()"
                >
                  Reset
                  <v-icon color="orange">donut_large</v-icon>
                </v-btn>
              </v-card-actions>
            </v-flex>
          </FilterBoard>

          <ScrollableTable
            ref="tableScroll"
            class="transporter-drivers-table-scroll oms-list-table-scroll"
            min-width="100%"
          >
            <v-data-table
              id="driversTable"
              class="transporter-driver-modern-table oms-list-table"
              :headers="headers"
              hide-actions
              :items="items"
              :loading="loading"
            >
              <template slot="items" slot-scope="props">
                <td :class="{ 'text-red': props.item.isDocumentsExpiry }">
                  <div class="oms-id-cell drivers-id-cell">
                    <activityLogs
                      :type="'driver'"
                      :id="props.item.driverId.toString()"
                    />
                    <span>{{ props.item.driverId }}</span>
                  </div>
                </td>
                <td>
                  <div class="transporter-drivers-country-cell">
                    <img
                      v-if="countryFlags[props.item.workingCountry]"
                      :src="countryFlags[props.item.workingCountry]"
                      :class="{
                        'transporter-drivers-flag--round':
                          props.item.workingCountry == 'UAE LA',
                      }"
                      class="transporter-drivers-flag"
                      alt=""
                    />
                    <span>{{ props.item.workingCountry || "-" }}</span>
                  </div>
                </td>
                <td>
                  <div class="transporter-drivers-stack">
                    <span>{{ getJobType(props.item.jobType) }}</span>
                    <span
                      v-if="props.item.jobType == '1' && props.item.borderType"
                      class="transporter-drivers-stack__sub"
                      >{{ getBorderType(props.item.borderType) }}</span
                    >
                  </div>
                </td>
                <td>
                  <div class="transporter-drivers-stack">
                    <span class="transporter-drivers-stack__main">{{
                      driverName(props.item)
                    }}</span>
                    <span
                      v-if="props.item.phoneNo && props.item.countryCode"
                      class="transporter-drivers-stack__sub transporter-drivers-phone"
                    >
                      <span
                        >{{ props.item.countryCode }}-{{ props.item.phoneNo }}</span
                      >
                      <a
                        v-if="props.item.isChatAvailable"
                        v-permissions="'drivers/true'"
                        target="_blank"
                        v-bind:href="
                          'https://test-support.trukkin.com/#!/messages?key=' +
                          t +
                          '&driverId=' +
                          props.item._id
                        "
                        title="WhatsApp"
                        class="transporter-drivers-chat-link"
                      >
                        <img
                          src="../../assets/whatsApp.png"
                          height="16"
                          width="16"
                          alt="WhatsApp"
                        />
                      </a>
                      <a
                        v-else
                        v-permissions="'drivers/true'"
                        title="No message present."
                        aria-disabled="true"
                        class="transporter-drivers-chat-link"
                      >
                        <img
                          src="../../assets/disableWhatApp.png"
                          height="16"
                          width="16"
                          alt=""
                        />
                      </a>
                    </span>
                  </div>
                </td>
                <td>
                  <div class="transporter-drivers-stack">
                    <span
                      class="transporter-drivers-stack__main transporter-drivers-vehicle"
                      >{{ vehicleNumber(props.item) }}</span
                    >
                    <span
                      v-if="props.item.subTruckType"
                      class="transporter-drivers-stack__sub"
                      >{{ getText(subTruck, props.item.subTruckType) }}</span
                    >
                  </div>
                </td>
                <td>
                  <div class="transporter-drivers-stack">
                    <span>{{ registeredAs(props.item) }}</span>
                    <span class="transporter-drivers-stack__sub">{{
                      deviceLabel(props.item)
                    }}</span>
                  </div>
                </td>
                <td>
                  <span
                    v-if="props.item.availabilityStatus"
                    class="transporter-drivers-pill transporter-drivers-pill--free"
                    >Free</span
                  >
                  <v-tooltip
                    v-else
                    top
                    content-class="tooltip-op"
                    color="orange"
                  >
                    <span
                      slot="activator"
                      class="transporter-drivers-pill transporter-drivers-pill--assigned"
                      >Assigned</span
                    >
                    <span class="tooltip"
                      >Assignment Id : {{ props.item.assignId }}</span
                    >
                  </v-tooltip>
                </td>
                <td>
                  <span
                    class="transporter-drivers-pill"
                    :class="
                      props.item.accountVerified
                        ? 'transporter-drivers-pill--verified'
                        : 'transporter-drivers-pill--unverified'
                    "
                  >
                    {{
                      props.item.accountVerified ? "Verified" : "Not Verified"
                    }}
                  </span>
                </td>
                <td>
                  <div class="transporter-drivers-actions">
                    <button
                      v-permissions="'view-profile-driver'"
                      @click="
                        goToUserProfile(
                          props.item.driverId,
                          props.item.workingCountry
                        )
                      "
                      type="button"
                      class="track-ass-btn"
                    >
                      Details
                    </button>

                    <button
                      v-permissions="'view-profile-driver'"
                      v-if="props.item.accountVerified == false"
                      @click="
                        verified(
                          props.item.driverId,
                          'true',
                          props.item.isBlocked
                        )
                      "
                      type="button"
                      class="view-ass-btn"
                    >
                      Verify
                    </button>
                    <button
                      @click="
                        verified(
                          props.item.driverId,
                          props.item.accountVerified.toString(),
                          'false'
                        )
                      "
                      v-if="props.item.isBlocked"
                      type="button"
                      class="track-ass-btn yellow-button"
                      title="Unblock Driver"
                    >
                      Unblock
                    </button>

                    <button
                      @click="
                        verified(
                          props.item.driverId,
                          props.item.accountVerified.toString(),
                          'true'
                        )
                      "
                      v-if="!props.item.isBlocked"
                      type="button"
                      class="track-ass-btn red-button"
                      title="Block Driver"
                    >
                      Block
                    </button>
                  </div>
                </td>
              </template>
              <template slot="no-data">
                <span class="transporter-drivers-empty">
                  {{ loading ? "Loading drivers..." : "No drivers found" }}
                </span>
              </template>
            </v-data-table>
          </ScrollableTable>
          <div class="transporter-drivers-pagination">
            <span class="transporter-drivers-pagination__summary">{{
              paginationSummary
            }}</span>
            <v-pagination
              v-if="totalPages > 0"
              :value="currentPage"
              :length="totalPages"
              :total-visible="7"
              :disabled="loading"
              circle
              @input="goToPage"
            />
          </div>
        </div>
      </v-card-text>
      <success-dialog
        :content="message"
        :show="success"
        :onclose="closeMessage"
      />
      <v-snackbar
        :timeout="6000"
        bottom
        color="red darken-2"
        v-model="error"
        class="white--text"
        v-if="error"
        >{{ error }}</v-snackbar
      >
    </v-card>
  </v-container>
</template>

<script>
import SelectCountry from "../Common/SelectCountry";
import { EventBus } from "../../event-bus.js";
import { transporterDriverList } from "@/constants/datatable-headers.js";
import Swal from "sweetalert2";
import activityLogs from "../Common/activityLogs";
import SuccessDialog from "@/components/Common/SuccessDialog";
import ScrollableTable from "@/components/Common/ScrollableTable";
import FilterBoard from "@/components/Common/FilterBoard";
import { StorageKeys, TruckTypes } from "../../constants/constants";
import Loading from "vue-loading-overlay";
import { transporter } from "../../constants/api-urls";

const PAGE_SIZE = 15;

const COUNTRY_FLAGS = {
  PAK: require("../../assets/pakflag.png"),
  KSA: require("../../assets/ksaflag.png"),
  UAE: require("../../assets/Uaeflag.png"),
  "UAE LA": require("../../assets/Uaeflag.png"),
  OMAN: require("../../assets/omanflag.png"),
};

export default {
  created() {
    this.checkPermission("drivers");
    this.$eventBus.$on("transporterDriver", this.refreshDrivers);
    EventBus.$on("countryChanged", this.onCountryChanged);

    if (this.$route.query && this.$route.query.workingCountry) {
      let workingCountries = [];
      if (localStorage.getItem("workingCountries")) {
        workingCountries = JSON.parse(localStorage.getItem("workingCountries"));
      }

      let key = this.$route.query.workingCountry;
      EventBus.$emit("setCountriesfromUrl", key);
      workingCountries.forEach((element) => {
        element.isSelected = element.value === key;
      });
      localStorage.setItem(
        "workingCountries",
        JSON.stringify(workingCountries)
      );
    }

    this.t = localStorage.getItem(StorageKeys.SessionKey);
    this.fetchDrivers();
  },
  beforeDestroy() {
    this.$eventBus.$off("transporterDriver", this.refreshDrivers);
    EventBus.$off("countryChanged", this.onCountryChanged);
  },
  components: {
    Loading,
    SuccessDialog,
    activityLogs,
    SelectCountry,
    ScrollableTable,
    FilterBoard,
  },
  data() {
    return {
      changeTabListing: "drivers",
      selectCountryDialog: false,
      availableStatus: [
        { text: "Free", value: "true" },
        { text: "Assigned", value: "false" },
      ],
      status: "",
      showScreen: true,
      operationName: "",
      subTruck: TruckTypes,
      countryFlags: COUNTRY_FLAGS,
      processing: false,
      success: false,
      message: "",
      error: null,
      t: "",
      search: {
        text: "",
      },
      searchItems: [
        { status: "Driver Name", abbr: "driverName" },
        { status: "Driver ID", abbr: "driverId" },
      ],
      searchTypes: "",
      payload: this.defaultPayload(),
      totalDrivers: 0,
      loading: false,
      driversRequestId: 0,
      headers: transporterDriverList,
      items: [],
    };
  },
  computed: {
    currentPage() {
      return Math.floor(Number(this.payload.skip || 0) / PAGE_SIZE) + 1;
    },
    totalPages() {
      return Math.ceil(this.totalDrivers / PAGE_SIZE);
    },
    paginationSummary() {
      if (!this.totalDrivers) {
        return this.loading ? "" : "No drivers";
      }
      const from = Number(this.payload.skip || 0) + 1;
      const to = from + this.items.length - 1;
      const noun = this.totalDrivers === 1 ? "driver" : "drivers";
      return `Showing ${from}-${to} of ${this.totalDrivers} ${noun}`;
    },
  },
  watch: {
    payload: {
      handler() {
        this.fetchDrivers();
      },
      deep: true,
    },
  },
  methods: {
    defaultPayload() {
      return {
        skip: "0",
        limit: String(PAGE_SIZE),
        transporterId: this.$route.params._id,
        workingCountry: this.$route.params.country,
      };
    },
    fetchDrivers() {
      const requestId = ++this.driversRequestId;
      this.loading = true;
      delete this.axios.defaults.headers.common["token"];
      const token = localStorage.getItem(StorageKeys.SessionKey);
      const config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.axios
        .post(
          this.constants.apiUrl + transporter.transporterDriver,
          this.payload,
          config
        )
        .then(
          (response) => {
            // A newer filter or page change superseded this request.
            if (requestId !== this.driversRequestId) return;
            const { list = [], totalData = 0 } = response.data.data || {};
            this.items = list;
            this.totalDrivers = totalData;
            this.loading = false;
            const scroll = this.$refs.tableScroll;
            if (scroll && scroll.$el) scroll.$el.scrollTop = 0;
          },
          (error) => {
            if (requestId !== this.driversRequestId) return;
            this.items = [];
            this.totalDrivers = 0;
            this.loading = false;
            this.error =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              "Failed to fetch drivers";
          }
        );
    },
    refreshDrivers() {
      this.fetchDrivers();
    },
    onCountryChanged() {
      // Drivers here are scoped to this transporter's country; a global
      // country switch takes the user back to the transporter list.
      if (this.$route.name == "transporter-driver-detail") {
        this.$router.push(`/transporter`);
      }
    },
    goToPage(page) {
      this.$set(this.payload, "skip", String((page - 1) * PAGE_SIZE));
    },
    filterByTab(value) {
      this.changeTabListing = value;
    },
    async checkAdd() {
      this.operationName = "register-new-driver";
      let y = await this.checkOpertaionPermission(this.operationName);

      if (y && localStorage.getItem("workingCountries")) {
        this.$router.push(
          `/transporter/add/${this.$route.params._id}/${this.$route.params.country}`
        );
      }
    },
    checkPermission(operation) {
      const { serverUrl, rbacUrl, apiUrl } = this.constants;
      this.$http
        .post(`${rbacUrl}/checkUserPermission`, {
          userId: localStorage.getItem("userId"),
        })
        .then((res) => {
          if (!res.data.data) {
            this.loading = false;
          }
          let old = res.data.data.roles;
          old = old.map((x) => x.role.roleName.toLowerCase());

          let roles = JSON.parse(localStorage.getItem("permissions")).roles;
          roles = roles.map((x) => x.role.roleName.toLowerCase());

          old.sort();
          roles.sort();

          if (old.toString() != roles.toString()) {
            this.showScreen = false;
            localStorage.setItem("permissions", JSON.stringify(res.data.data));
            Swal.fire({
              title: "Oops!",
              text: "Your permissions have changed .",
              type: "error",
              allowOutsideClick: false,
              allowEscapeKey: false,
              confirmButtonColor: "orange",
              confirmButtonText: "Okay",
            }).then((result) => {
              localStorage.setItem("first-load", true);
              this.$router.replace("/");
              location.reload();
            });
          }
          if (old.toString() == roles.toString()) {
            localStorage.setItem("permissions", JSON.stringify(res.data.data));
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },

    getText(arr = [], val) {
      let finalEl = null;
      finalEl = arr.find((el) => el.value == val);

      return finalEl ? finalEl.text : "NA";
    },
    getBorderType(type) {
      switch (type) {
        case "Local":
          return "Local";
        case "OutOfBorder":
          return "Cross Country";
      }
    },
    getJobType(type) {
      switch (type) {
        case "1":
          return "Land";
        case "2":
          return "Air";
        case "3":
          return "Sea";
        default:
          return "Land";
      }
    },
    driverName(item) {
      return [item.firstName, item.lastName].filter(Boolean).join(" ") || "-";
    },
    vehicleNumber(item) {
      if (!item.truckNumber) return "-";
      if (!item.truckPrefix || item.truckPrefix == "Others") {
        return item.truckNumber;
      }
      return `${item.truckPrefix}-${item.truckNumber}`;
    },
    registeredAs(item) {
      if (!item.ownerType) return "-";
      const ownerType = Array.isArray(item.ownerType)
        ? item.ownerType.join(", ")
        : String(item.ownerType);
      return ownerType || "Owner";
    },
    deviceLabel(item) {
      if (item.deviceType == "ANDROID") return "DRIVER APP";
      return item.deviceType || "-";
    },
    closeMessage() {
      this.success = false;
      this.fetchDrivers();
    },
    verified(id, status, status1) {
      this.processing = true;
      let Url = transporter.blockAndVerifyDriver;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      let body = {
        driverId: id.toString(),
        accountVerified: status,
        isBlocked: status1.toString(),
      };
      this.axios.post(this.constants.apiUrl + Url, body, config).then(
        (response) => {
          this.success = true;
          this.processing = false;
        },
        (error) => {
          this.success = false;
          this.processing = false;
          this.error = error.response.data.message;
          setTimeout(() => {
            this.error = "";
          }, 6000);
        }
      );
    },
    goToUserProfile(driverId, workingCountry) {
      this.$router.push(
        `/transporter/driver-edit/${this.$route.params.id}/${this.$route.params._id}/${driverId}/${workingCountry}/profile`
      );
    },

    searchByType() {
      this.search.text = "";
      this.searchDriver();
    },
    searchDriverStatus() {
      if (this.status) {
        this.payload.skip = "0";
        this.$set(this.payload, "status", this.status);
      }
    },
    searchDriver() {
      const text = this.search.text.trim();
      this.payload.skip = "0";
      if (text.length > 0) {
        this.$set(this.payload, "searchType", this.searchTypes.abbr);
        this.$set(this.payload, "searchText", text);
        return;
      }
      // Clearing the box (or switching search type) drops the text filter.
      this.$delete(this.payload, "searchType");
      this.$delete(this.payload, "searchText");
    },

    resetSearch() {
      this.search.text = "";
      this.searchTypes = "";
      this.status = "";
      this.payload = this.defaultPayload();
    },
  },
};
</script>

<style lang="scss">
.text-red {
  color: red;
}
</style>
